exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MobileView_mobileViewOverlay__2bQG7{position:fixed;z-index:61;top:0;right:0;left:0;bottom:0;display:-webkit-flex;display:flex;overflow-y:auto;background-color:#fff;-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-flex-direction:column;flex-direction:column}.MobileView_mobileViewOverlay__2bQG7 .MobileView_mobileSearchResults__9yI2p{overflow-y:auto}.MobileView_mobileViewOverlay_visible__3Sa7C{-webkit-transform:translateY(0);transform:translateY(0)}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333333",
	"textGray": "#9b9b9b",
	"textWhite": "#ffffff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"mobileViewOverlay": "MobileView_mobileViewOverlay__2bQG7",
	"mobileSearchResults": "MobileView_mobileSearchResults__9yI2p",
	"mobileViewOverlay_visible": "MobileView_mobileViewOverlay_visible__3Sa7C"
};